export const Data = [
  {
    type: "zh",
    imgBoxUrl:"https://www.victrum.com/image/tp/新网中心banner.png",
    newDate: [

      {
        index:"code15",
        imgUrl:"https://www.victrum.com/image/news/code15.png",
        text1:"口腔激光治疗仪正式入驻西安医学院第三附属医院",
        text2:"2026年6月30日",
        text3:"设备落地｜微创未来Er:YAG口腔激光治疗仪正式入驻西安医学院第三附属医院！",
        text4:"查看详情",
      },
      {
        index:"code17",
        imgUrl:"https://www.victrum.com/image/news/code17.png",
        text1:"西部行口腔激光培训班圆满落幕",
        text2:"2026年6月29日",
        text3:"西部行口腔激光培训班圆满落幕｜微创未来铒激光实操获业内好评",
        text4:"查看详情",
      },
      {
        index:"code10",
        imgUrl:"https://www.victrum.com/image/news/code10.png",
        text1:"四天相聚，满载而归",
        text2:"2026年6月14日",
        text3:"四天相聚，满载而归 | 北京国际口腔展圆满结束，感恩每一次相遇",
        text4:"查看详情",
      },

      {
        index:"code8",
        imgUrl:"https://www.victrum.com/image/news/code8.png",
        text1:"第一届口腔激光临床应用学习",
        text2:"2026年5月25日",
        text3:"上海九院第一届口腔激光临床应用学习班圆满落幕",
        text4:"查看详情",
      },
      {
        index:"code14",
        imgUrl:"https://www.victrum.com/image/png/code14.png",
        text1:"微创未来入驻西安交通大学第一附属医院口腔科",
        text2:"2026年4月7日",
        text3:"微创未来入驻西安交通大学第一附属医院口腔科  赋能精准口腔诊疗",
        text4:"查看详情",
      },


      {
        index:"hxkq",
        imgUrl:"https://www.victrum.com/image/news/hxkq.jpg",
        text1:"重磅合作",
        text2:"2025年12月26日",
        text3:"微创未来铒激光正式入驻华西口腔，全程护航临床诊疗",
        text4:"查看详情",
      },

      {
        index:"code7",
        imgUrl:"https://www.victrum.com/image/png/code7.png",
        text1:"口腔激光年会收官",
        text2:"2025年11月3日",
        text3:"口腔激光年会收官：选铒激光看这 3 点，微创未来用实力说话！",
        text4:"查看详情",
      },

      {
        index:"code5",
        imgUrl:"https://www.victrum.com/image/png/code5.png",
        text1:"成都牙周年会",
        text2:"2025年10月24日",
        text3:"成都牙周年会落幕！微创未来铒激光成 “流量密码”，临床实力藏不住了",
        text4:"查看详情",
      },

      {
        index:"code13",
        imgUrl:"https://www.victrum.com/image/png/code13.jpg",
        text1:"南昌研修班圆满收官",
        text2:"2025年9月28日",
        text3:"口腔铒激光舒适化治疗研修班（南昌站）圆满收官",
        text4:"查看详情",
      },
      {
        index:"code16",
        imgUrl:"https://www.victrum.com/image/png/code16.jpg",
        text1:"微创未来FDI 上海展圆满落幕",
        text2:"2025年9月15日",
        text3:"微创未来FDI 上海展圆满落幕！深耕激光技术，共探口腔新未来",
        text4:"查看详情",
      },
      {
        index:"code12",
        imgUrl:"https://www.victrum.com/image/png/code12.png",
        text1:"微创未来诚邀您相聚长春",
        text2:"2025年8月29日",
        text3:"微创未来诚邀您相聚长春！5 号展位共探口腔种植前沿技术",
        text4:"查看详情",
      },
      {
        index:"code19",
        imgUrl:"https://www.victrum.com/image/png/code19.png",
        text1:"【宿迁站】微创未来铒激光研修班收官",
        text2:"2025年8月25日",
        text3:"【宿迁站】微创未来铒激光研修班收官！承霸王风骨，携前沿技术共启口腔新程",
        text4:"查看详情",
      },
      {
        index:"code2",
        imgUrl:"https://www.victrum.com/image/png/code2.png",
        text1:"永林口腔&微创未来",
        text2:"2025年8月5日",
        text3:"【永林口腔&微创未来】舒适化激光诊疗中心正式授牌，开启口腔诊疗新时代！",
        text4:"查看详情",
      },
      {
        index:"code1",
        imgUrl:"https://www.victrum.com/image/png/code1.png",
        text1:"行业重磅",
        text2:"2025年7月1日",
        text3:"【行业重磅】微创未来与 BITC 达成战略合作，开启口腔种植激光诊疗新纪元！",
        text4:"查看详情",
      },


      {
        index:"code6",
        imgUrl:"https://www.victrum.com/image/png/code6.png",
        text1:"口腔激光技术学习班（太原站）",
        text2:"2025年7月1日",
        text3:"口腔激光技术学习班（太原站）圆满落幕",
        text4:"查看详情",
      },
      {
        index:"code9",
        imgUrl:"https://www.victrum.com/image/png/code9.png",
        text1:"双项领军人才计划加持",
        text2:"2025年7月1日",
        text3:"双项领军人才计划加持，牙客邦口腔Er:YAG激光治疗仪引领口腔治疗新风潮！",
        text4:"查看详情",
      },
      {
        index:"code11",
        imgUrl:"https://www.victrum.com/image/png/code11.png",
        text1:"苏州牙客邦",
        text2:"2025年7月1日",
        text3:"苏州牙客邦| 携手宿迁口腔医院，共启微创激光诊疗新时代！",
        text4:"查看详情",
      },

      {
        index:"code4",
        imgUrl:"https://www.victrum.com/image/png/code4.png",
        text1:"北京展",
        text2:"2025年6月16日",
        text3:"北京展 | 微创未来炫彩铒激光，点亮口腔诊疗新视界",
        text4:"查看详情",
      },
      {
        index:"code3",
        imgUrl:"https://www.victrum.com/image/png/code3.png",
        text1:"2025 西部口腔展",
        text2:"2025年4月16日",
        text3:"2025 西部口腔展：邂逅微创未来，开启铒激光口腔诊疗新时代",
        text4:"查看详情",
      },
      {
        index:"code18",
        imgUrl:"https://www.victrum.com/image/png/code18.png",
        text1:"微创未来「口腔铒激光治疗仪」荣获第八届中关村国际前沿科技大赛第二名",
        text2:"2025年3月10日",
        text3:"喜报！微创未来「口腔铒激光治疗仪」荣获第八届中关村国际前沿科技大赛第二名！",
        text4:"查看详情",
      },
      {
        index:"hngjkqz",
        imgUrl:"https://www.victrum.com/image/news/hngjkqz.png",
        text1:"华南口腔展",
        text2:"2025年2月25日",
        text3:"口腔科技巅峰对决，微创未来闪耀华南口腔展",
        text4:"查看详情",
      },

      {
        index:"kjrz",
        imgUrl:"https://www.victrum.com/image/news/kjrz.png",
        text1:"微创未来铒激光获北京 2024 首台（套）装备认证",
        text2:"2025年1月21日",
        text3:"微创未来铒激光获北京 2024 首台（套）装备认证",
        text4:"查看详情",
      },
      {
        index:"gyy",
        imgUrl:"https://www.victrum.com/image/nr/news/3.jpg",
        text1:"郑州展",
        text2:"2024年03月27日  下午",
        text3:"微创未来 | 3月郑州有请！",
        text4:"查看详情",
      },
      {
        index:"gss",
        imgUrl:"https://www.victrum.com/image/nr/news/1.jpg",
        text1:"华南展",
        text2:"2024年03月19日",
        text3:"Er:YAG激光治疗仪2024年首次亮相圆满收官!！",
        text4:"查看详情",
      },
      // {
      //   index:"gxz",
      //   imgUrl:"https://www.victrum.com/image/nr/news/2.jpg",
      //   text1:"东北展",
      //   text2:"2024年03月20日",
      //   text3:"2024年东北国际口腔展隆重开幕，微创未来邀请您相约沈阳！",
      //   text4:"查看详情",
      // },

      // {
      //   index:"ghzg",
      //   imgUrl:"https://www.victrum.com/image/news/twz.png",
      //   text1:"台湾展",
      //   text2:"2024年10月23日",
      //   text3:"国货之光 | 亮相台湾！",
      //   text4:"查看详情",
      // },





























    ]
  },
  {
    type: "en",
    imgBoxUrl:"https://www.victrum.com/image/tp/新网中心banner.png",
    newDate: [
      {
        index:"gss",
        imgUrl:"https://www.victrum.com/image/nr/news/1.jpg",
        text1:"South China Exhibition",
        text2:"March 19, 2024, Afternoon",
        text3:"Er:YAG Laser Treatment System’s First Appearance in 2024 Concludes Successfully!",
        text4:"查看详情",
      },
      // {
      //   index:"gxx",
      //   imgUrl:"https://www.victrum.com/image/nr/news/2.jpg",
      //   text1:"Northeast Exhibition",
      //   text2:"March 20, 2024, Afternoon",
      //   text3:"The Grand Opening of the 2024 Northeast International Dental Exhibition - Micro-Innovation Invites You to Shenyang!",
      //   text4:"查看详情",
      // },
      {
        index:"gyy",
        imgUrl:"https://www.victrum.com/image/nr/news/3.jpg",
        text1:"Zhengzhou Exhibition",
        text2:"March 27, 2024, Afternoon",
        text3:"Micro-Innovation | March in Zhengzhou Awaits You!",
        text4:"查看详情",
      },
      // {
      //   index:"ghzg",
      //   imgUrl:"https://www.victrum.com/image/news/twz.png",
      //   text1:"Taiwan Exhibition",
      //   text2:"October 23, 2024",
      //   text3:"The Pride of Domestic Brands | Appearing in Taiwan！",
      //   text4:"查看详情",
      // },
      {
        index:"hngjkqz",
        imgUrl:"https://www.victrum.com/image/news/hngjkqz.png",
        text1:"South China Dental Exhibition",
        text2:"February 25, 2025",
        text3:"2-The Pinnacle Showdown of Oral Science and Technology Victrum Shines at the South China Dental Show",
        text4:"查看详情",
      } ,
      {
        index:"kjrz",
        imgUrl:"https://www.victrum.com/image/news/kjrz.png",
        text1:"Victrum's Erbium Laser Obtains Beijing's 2024 First Set (Unit) of Equipment Certification",
        text2:"January 21, 2025",
        text3:"Victrum's Erbium Laser Obtains Beijing's 2024 First Set (Unit) of Equipment Certification",
        text4:"查看详情",
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/js/news.js